import React from 'react'

const TextButtonDocFinalProduct = ({
  onClickViewDocs,
  idPresentation,
  isEditProductPresentation,
  onlyViewDocsProduct,
}) => {
  // Determinar el texto basado en los condicionales
  const getButtonText = () => {
    if (idPresentation !== undefined && !onlyViewDocsProduct) {
      if (isEditProductPresentation) {
        return 'Editar producto'
      } else {
        return 'Añadir producto'
      }
    }
    return 'Documentos'
  }

  return (
    <button
      onClick={() => onClickViewDocs()}
      className='product-detail__tab'
      type='button'
    >
      <span className='tab-text'>{getButtonText()}</span>
    </button>
  )
}

export default TextButtonDocFinalProduct
